import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/core/auth/_services';
import { StringUtilsService } from '../../../../core/services/string-utils.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ContactsService } from '../../../../core/lists';
import { GeneralAutocompleteComponent } from '../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { FollowUpService } from '../../../../core/services/follow-up.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-new-attempt-dialog',
  templateUrl: './attempt-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttemptListComponent implements OnInit, OnDestroy {
  contactAutocompleteCall = this.contactsService.searchContactsFollowups.bind(
    this.contactsService,
    this.data.relatedIds,
  );
  @ViewChild('followupContactAutocomplete')
  followupContactAutocomplete: GeneralAutocompleteComponent;
  reasonAutocompleteCall = this.followUpService.searchReasons.bind(this.followUpService);
  @ViewChild('reasonAutocomplete') reasonAutocomplete: GeneralAutocompleteComponent;
  attemptForm: FormGroup;
  hasFormErrors: boolean;
  followUp;
  comments = [];
  attemptsDataSource: any;
  displayedAttemptColumns = ['attempt', 'contact', 'start', 'end', 'reason', 'comment'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AttemptListComponent>,
    private userService: UserService,
    private store: Store<AppState>,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    public datePipe: DatePipe,
    private fb: FormBuilder,
    private contactsService: ContactsService,
    private followUpService: FollowUpService,
    public stringUtils: StringUtilsService,
  ) {}

  ngOnInit() {
    this.attemptsDataSource = this.data.attempts;
  }

  getTitle() {
    return 'History';
  }

  ngOnDestroy() {
    this.cdr.detach();
  }

  close() {
    this.dialogRef.close();
  }

  getContact(id) {
    if (this.data.contacts && this.data.contacts.length > 0)
      if (
        this.data.contacts.filter((item) => item.id === id)[0] !== null &&
        this.data.contacts.filter((item) => item.id === id)[0] !== undefined
      ) {
        return (
          this.data.contacts.filter((item) => item.id === id)[0].first_name +
          ' ' +
          this.data.contacts.filter((item) => item.id === id)[0].last_name
        );
      }
  }

  getStarted(index) {
    if (index >= 0)
      return this.data.attempts && this.data.attempts[index]
        ? this.data.attempts[index].rev_timestamp
        : '';
  }

  getEnded(index) {
    if (index >= 0)
      return this.data.attempts && this.data.attempts[index + 1]
        ? this.data.attempts[index + 1].rev_timestamp
        : '';
  }
}
